var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wtp",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();}}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#005f7b"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }